/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React, { FC } from 'react';
import { Col } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { Tile } from '@cloudcar-app/cloudcar-components';
import { InsuranceSimulationProduct } from 'apollo/types';
import styles from './InsuranceSuccess.module.scss';

interface InsuranceSuccessProps {
  document: string;
  selectedProduct: InsuranceSimulationProduct;
}

const InsuranceSuccess: FC<InsuranceSuccessProps> = (
  props: InsuranceSuccessProps,
) => {
  const { document, selectedProduct } = props;

  return (
    <>
      <Tile
        style={{
          background: '#F6FFED',
          border: '1px solid #B7EB8F',
          marginTop: '24px',
          padding: '24px',
        }}
      >
        <Col>
          {selectedProduct.insuranceProvider === 'CHILEAN' ? (
            <h2>¡Felicidades! ¡Tu suscripción de pago ha sido autorizada!</h2>
          ) : (
            <h2>¡Felicidades! ¡Tu seguro ha sido contratado!</h2>
          )}
        </Col>
        {selectedProduct.insuranceProvider === 'HDI' && (
          <Col>
            <a
              download="poliza.pdf"
              href={`data:application/pdf;base64,${document}`}
            >
              <DownloadOutlined /> Descargar póliza
            </a>
          </Col>
        )}
        {selectedProduct.insuranceProvider === 'BCI' && (
          <Col>
            <div
              onClick={(event) => {
                event.stopPropagation();
                window.open(document, '_blank');
              }}
            >
              <p className={styles.DownloadInfo}>Descargar Poliza</p>
            </div>
          </Col>
        )}
      </Tile>
    </>
  );
};

export default InsuranceSuccess;
